module.exports = __webpack_public_path__ + "img/footer-standard-malaysia-acb-021.6034b07f.png";